import './searchfield.less'

import {m, View} from '@codeurs/front'
import {ArrowIcon, SearchIcon} from 'assets/inline-icons'
import {FunctionComponent} from 'react'
import {Mod, style} from 'util/style'

const styles = style('searchfield', ['submit'])

export const SearchField: FunctionComponent<{
	white?: boolean
	mobile?: boolean
}> = ({white, children, mobile, ...props}) => (
	<div class={styles.mod({white, mobile})}>
		{!white && <SearchIcon className={styles('icon')} />}
		{children}
		<SearchFieldSubmit />
	</div>
)

export const SearchFieldSubmit = () => (
	<button type="submit" title="Search submit" class={styles.submit}>
		<ArrowIcon className={styles.submit('icon')} />
	</button>
)
